import { createContext, useContext } from 'react';

export type InputLabelContextType = {
  /**
   * Id for an input element that has its label rendered somewhere outside the
   * input component
   */
  inputId?: string;
};

/**
 * Context used to coordinate layout properties across form page components.
 * Only used internally.
 */
export const InputLabelContext = createContext<InputLabelContextType>({});

/**
 * @throws
 * Throws an error if an input element is rendered without an accessible label.
 * The label can be inside the input component or outside the component if the
 * component's id is provided to InputLabelContext.
 */
export const useCheckInputLabel = (label?: string) => {
  const { inputId } = useContext(InputLabelContext);

  if (!inputId && !label) {
    throw new Error(
      'Tried to render an input element without an accessible label. Please check that all input components have a non-empty `title` prop.',
    );
  }
};
